import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routeModules = require.context("./groups", true, /routes\.js$/);
const routes = [];

routeModules.keys().forEach((fileName) => {
  const routeModule = routeModules(fileName).default;
  routes.push(...routeModule);
});

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("userData");
  const userAceess = JSON.parse(isLoggedIn);
  const userLevel = userAceess ? userAceess.role : null;
  const userSublevel = userAceess ? userAceess.sublevel : null;

  const requiredLevel = to.meta.requiredLevel;
  const allowedProvinsiSublevels = to.meta.allowedProvinsiSublevels;

  if (
    !isLoggedIn &&
    !to.meta.public &&
    to.path !== "/login" &&
    to.path !== "/home" &&
    to.path !== "/"
  ) {
    next("/");
  } else if (to.path === "/login" && isLoggedIn) {
    next("/dashboard");
  } else if (requiredLevel) {
    if (!userLevel || !requiredLevel.includes(userLevel)) {
      return next("/forbidden");
    }
    return next();
  } else if (
    userLevel === "admin_provinsi" &&
    Array.isArray(allowedProvinsiSublevels) &&
    !allowedProvinsiSublevels.includes(userSublevel)
  ) {
    return next("/forbidden");
  } else {
    next();
  }
});

router.afterEach((to) => {
  document.title = `Digitalisasi Perkebunan dan Peternakan Sulawesi Tengah - ${to.meta.title || "App"}`;
});

export default router;
